import { render, staticRenderFns } from "./paso2.vue?vue&type=template&id=470f7c64&scoped=true&"
import script from "./paso2.vue?vue&type=script&lang=ts&"
export * from "./paso2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470f7c64",
  null
  
)

export default component.exports